import React from 'react';
import { Button } from '@monavate/ui-core';
import { useAuth0 } from '@auth0/auth0-react';
import styled from 'styled-components';

const Wrapper = styled.span`
    .icon {
        font-weight: 300;
        margin-right: 8px;
    }
`;

const SignInButton = () => {
    const { loginWithRedirect } = useAuth0();
    const onLogInClickHandler = () => {
        loginWithRedirect();
    };
    return (
        <Wrapper>
            <Button
                dataTestId="button-sign-in"
                viewType={'primary'}
                size="middle"
                handleClick={onLogInClickHandler}
            >
                Sign In
            </Button>
        </Wrapper>
    );
};

export default SignInButton;
